export default __webpack_public_path__ + "static/image_acceuil-3d3ffd879a14b07e1c7547099e1ce9a4.jpg";